/* eslint-disable  */
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { BiSupport } from "react-icons/bi";
import { BsCalendar2DateFill } from "react-icons/bs";
import { GrStatusInfo } from "react-icons/gr";
import { MdOutlineUpdate, MdArrowBack, MdSend } from "react-icons/md";
import { Send } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import { messagesActionCreators } from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../service/action-creators/userDataAction";
import RenderHome from "../home/RenderHome";

function MessageDetailed() {
  const dispatch = useDispatch();
  const history = useHistory();
  const scrollRef = useRef();
  const chat_id = history.location?.state?.chat_id;
  const {
    ResetMessagesResponse,
    addMessages,
    DeleteMessage,
    CloseMessage,
    getMessageDetailed,
    GetTotalUnreadMessages,
  } = bindActionCreators(messagesActionCreators, dispatch);
  const [formData, setFormData] = useState({ message: "" });

  useEffect(() => {
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    dispatch(GetCartProducts());
    GetTotalUnreadMessages();
  }, []);

  useEffect(() => {
    getMessageDetailed(chat_id);
  }, [chat_id]);

  const auth = useSelector((state) => state.auth);
  const chat = useSelector((state) => state.messages);

  const { messageDetailed, response, isLoading } = chat;

  console.log("chat_id", chat_id);
  console.log("chat", chat);
  console.log("auth", auth);

  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.message === "") {
      toast.success("Message box is empty");
    } else {
      const payload = {
        ...formData,
        user_id: auth?.user?._id,
        reference: messageDetailed?.reference,
      };
      addMessages(payload);
      setFormData({ ...formData, message: "" });
    }
  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messageDetailed?.chat]);

  useEffect(() => {
    if (response.state === "SUCCESS") {
      getMessageDetailed(chat_id);
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    } else if (response.state === "ERROR") {
      toast.error(response?.message ?? "unable to get notification");
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    } else if (response.state === "DELETED") {
      toast.success(response?.message ?? "deleted successfully");
      setTimeout(() => {
        ResetMessagesResponse();
        history.goBack();
      }, 1500);
    }
  }, [response.state, response?.message]);

  return (
    <RenderHome>
      <div className="min-h-screen bg-gray-50">
        {/* Header Section */}
        <div className="bg-white shadow-sm border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-4">
              <div className="space-x-4">
                <button
                  onClick={() => history.goBack()}
                  className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                  <MdArrowBack className="h-4 w-4 mr-2" />
                  Back
                </button>
              </div>

              <div className="flex items-center space-x-3">
                {/* <button
                  onClick={() => CloseMessage(messageDetailed?._id)}
                  className="inline-flex items-center px-4 py-2 border border-yellow-300 shadow-sm text-sm font-medium rounded-md text-yellow-700 bg-yellow-50 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors duration-200"
                >
                  Close
                </button> */}
                <button
                  onClick={() => DeleteMessage(messageDetailed?._id)}
                  className="inline-flex items-center px-4 py-2 border border-red-300 shadow-sm text-sm font-medium rounded-md text-white bg-red-400 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 py-2">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Info Panel */}
            <div className="w-full lg:w-96 flex-shrink-0">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h2 className="text-lg font-medium text-gray-900 mb-6">
                  {messageDetailed?.subject}
                </h2>

                <div className="grid grid-cols-2 md:grid-cols-4 lg:flex-row lg:justify-between xl:grid-cols-4 gap-4">
                  {/* Status */}
                  <div className="flex flex-col items-start">
                    <div className="flex items-center space-x-2 mb-1">
                      <GrStatusInfo className="h-5 w-5 text-gray-400" />
                      <dt className="text-sm font-medium text-gray-500">
                        Status
                      </dt>
                    </div>
                    <dd className="w-full">
                      <span
                        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          messageDetailed?.isOpen
                            ? "bg-green-100 text-green-800"
                            : "bg-gray-100 text-gray-800"
                        }`}
                      >
                        {messageDetailed?.isOpen ? "Open" : "Closed"}
                      </span>
                    </dd>
                  </div>

                  {/* Department */}
                  <div className="flex flex-col items-start">
                    <div className="flex items-center space-x-2 mb-1">
                      <BiSupport className="h-5 w-5 text-gray-400" />
                      <dt className="text-sm font-medium text-gray-500">
                        Department
                      </dt>
                    </div>
                    <div className="text-sm text-gray-900 w-full truncate">
                      {messageDetailed?.system_user}
                    </div>
                  </div>

                  {/* Last Updated */}
                  <div className="flex flex-col items-start">
                    <div className="flex items-center space-x-2 mb-1">
                      <MdOutlineUpdate className="h-5 w-5 text-gray-400" />
                      <dt className="text-sm font-medium text-gray-500">
                        Last Updated
                      </dt>
                    </div>
                    <dd className="text-sm text-gray-900 w-full">
                      {moment(messageDetailed?.updated_at).format("MMM Do YY")}
                    </dd>
                  </div>

                  {/* Submitted on */}
                  <div className="flex flex-col items-start">
                    <div className="flex items-center space-x-2 mb-1">
                      <BsCalendar2DateFill className="h-5 w-5 text-gray-400" />
                      <dt className="text-sm font-medium text-gray-500">
                        Submitted on
                      </dt>
                    </div>
                    <dd className="text-sm text-gray-900 w-full">
                      {moment(messageDetailed?.created_at).format("MMM Do YY")}
                    </dd>
                  </div>
                </div>
              </div>
            </div>

            {/* Chat Panel */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col h-[600px]">
                {/* Chat Header */}
                <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 rounded-t-lg">
                  <h2 className="text-lg font-medium text-gray-900">
                    Conversation
                  </h2>
                </div>

                {/* Messages Area */}
                <div className="flex-1 overflow-y-auto p-2 space-y-4 bg-gray-100">
                  {messageDetailed?.chat?.map((ch, index) => {
                    return ch?.user_type === "member" ? (
                      // User message (right side)
                      <div
                        ref={scrollRef}
                        key={index}
                        className="flex justify-end"
                      >
                        <div className="flex items-end gap-2 max-w-xs lg:max-w-md">
                          <div className="bg-green-500 text-white rounded-l-lg rounded-tr-lg rounded-br-lg px-3 py-2 shadow">
                            <p className="text-sm">{ch?.message}</p>
                            <p className="text-xs text-blue-100 opacity-80 mt-1 text-right">
                              {moment(ch?.date).format("HH:mm")}
                            </p>
                          </div>
                          <img
                            className="w-8 h-8 rounded-full flex-shrink-0 border-2 border-white shadow-sm"
                            src={auth?.user?.profile_image}
                            alt="Your profile"
                          />
                        </div>
                      </div>
                    ) : (
                      // Other user message (left side)
                      <div
                        ref={scrollRef}
                        key={index}
                        className="flex justify-start"
                      >
                        <div className="flex items-end gap-2 max-w-xs lg:max-w-md">
                          <img
                            className="w-8 h-8 rounded-full flex-shrink-0 border-2 border-white shadow-sm"
                            src={ch?.system_user_profile}
                            alt="Profile"
                          />
                          <div>
                            <div className="bg-white rounded-r-lg rounded-tl-lg rounded-bl-sm px-4 py-2 shadow border border-gray-200">
                              <p className="text-sm text-gray-800">
                                {ch?.message}
                              </p>
                            </div>
                            <p className="text-xs text-gray-500 mt-1 px-1">
                              {`${ch?.system_user?.split(" ")[1]} · ${moment(
                                ch?.date
                              ).format("HH:mm")}`}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* Message Input */}
                <div className="border-t border-gray-200 p-2 bg-white rounded-b-lg">
                  <form
                    onSubmit={handleSubmit}
                    className="flex items-end space-x-3"
                  >
                    <div className="flex flex-row justify-between w-full">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Type your message here..."
                        rows={1}
                        className="w-full resize-none border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200 text-sm"
                        style={{ minHeight: "30px" }}
                      />
                    </div>
                    <button
                      type="submit"
                      className="inline-flex items-center justify-center w-11 h-11 bg-blue-500 hover:bg-blue-600 text-white rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                    >
                      <Send className="h-5 w-5 text-green-500" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3000} />
    </RenderHome>
  );
}

export default MessageDetailed;
